import Cookies from 'js-cookie'
import website from '../config/website'

// 统一Cookie名称
const TokenKey = 'yzfc-access-token'
const RefreshTokenKey = 'yzfc-refresh-token'

// 从配置文件读取Cookie选项
const cookieOptions = {
    expires: website.cookieExpires || 30,
    domain: website.cookieDomain,  // 从配置文件读取，生产环境为'.yzfc.vip'，开发环境为undefined
    path: website.cookiePath || '/',
    secure: website.cookieSecure,  // 生产环境HTTPS启用
    sameSite: website.cookieSameSite  // 生产环境启用SameSite防CSRF
}

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, cookieOptions)
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token, cookieOptions)
}

export function removeToken() {
    return Cookies.remove(TokenKey, cookieOptions)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey, cookieOptions)
}

